import { ReactNode } from "react";

import { Container } from "@mui/material";

import { Background } from "@baseComponents/Background";
import { Menu } from "@components/menu";
import { PageMetadata, PageMetadataProps } from "@components/PageMetadata";

import Footer from "../footer";

import { MDXStyles } from "./styles.styled";

interface AboutUsLayoutProps extends PageMetadataProps {
  children?: ReactNode;
}

function AboutUsLayoutBody({
  children,
  title,
  description,
}: AboutUsLayoutProps) {
  return (
    <>
      <PageMetadata title={title} description={description} />

      <Background />

      <Menu />

      <Container maxWidth="desktopXl">
        <MDXStyles>{children}</MDXStyles>
      </Container>

      <Footer />
    </>
  );
}

export const AboutUsLayout = ({ children, ...rest }: AboutUsLayoutProps) => {
  return <AboutUsLayoutBody {...rest}>{children}</AboutUsLayoutBody>;
};
